import React from 'react'

import Center from '../../../packages/kiti/components/helpers/Center'
import Circle from '../../../packages/kiti/components/shapes/Circle'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Link from '../../../packages/kiti/components/actions/Link'
import Logo from '../../../components/shapes/Logo'

const HomeButton = () => {
  const [hover, setHover] = React.useState(false)

  return (
    <Link path="/home" block onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Center>
        {hover ? (
          <Circle bgColor="white" radius={0.1} size={2.5}>
            <Icon name="RiHome3Line" size={1.5} color="primary" />
          </Circle>
        ) : (
          <Logo white noText width="2.5rem" />
        )}
      </Center>
    </Link>
  )
}

export default HomeButton
